import script from "./AppSidebarNav.vue?vue&type=script&lang=js"
export * from "./AppSidebarNav.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__